module.exports = __webpack_public_path__ + "static/media/file.5f705eed.svg";